import { Box, InputBase, styled } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { EmojiEmotions, AttachFile, Mic,  } from '@mui/icons-material';
import { Upload } from '../../../server/Server';




const Container = styled(Box)`
height: 55px;
background: #ededed;
width: 100%;
display: flex;
align-items: center;
padding: 0 15px;
&  > * {
    margin: 5px;
    color: #919191;
}
`;

const Search = styled(Box)`
border-radius: 18px;
background-color: #FFFFFF;
width: calc(94% - 100px);
`;

const InputField = styled(InputBase)`
width: 100%;
padding: 20px;
padding-left: 25px;
font-size: 14px;
height: 20px;
width: 100%;
`;

const ClipIcon = styled(AttachFile)`
transform:rotate(40deg);
`;





function Footers({SentKeys,SetText,text ,file,SetFile ,SetImage}) {


    

    const hadleImage=(e)=>{
       
       SetText(e.target.files[0].name)
       SetFile(e.target.files[0])
    }


    useEffect(()=>{
     
      const  getImage= async()=>{
        if(file){
            const data=new FormData();
                  data.append("name",file.name)
                  data.append("file",file)
          let link =  await Upload(data)
          
          SetImage(link)
         }

      }
      getImage()

    },[file])


    return (
        <Container>
             <EmojiEmotions/>
             <label htmlFor='file'><ClipIcon  /></label>
             <input id='file' type='file' onChange={(e)=>hadleImage(e)}></input>
            <Search>
                <InputField
                    placeholder='type a message'
                    onChange={(e)=>SetText(e.target.value)}
                    onKeyPress={(e)=>SentKeys(e)}
                    value={text}
                    
                />
            </Search>
        </Container>
    )
}

export default Footers
